import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString1pkumu07cwy4m as toString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  RuntimeException1r3t0zl97011n as RuntimeException,
  VOID3gxj6tk5isa35 as VOID,
  captureStack1fzi4aczwc4hg as captureStack,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getKClass3t8tygqu4lcxf as getKClass,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  ArrayList3it5z8td81qkl as ArrayList,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString30pk9tzaqopn as toString_0,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {}
class RequestContext {
  constructor(initialClazz) {
    this.be4_1 = initialClazz;
  }
  toString() {
    return 'RequestContext(initialClazz=' + toString(this.be4_1) + ')';
  }
  hashCode() {
    return this.be4_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestContext))
      return false;
    var tmp0_other_with_cast = other instanceof RequestContext ? other : THROW_CCE();
    if (!this.be4_1.equals(tmp0_other_with_cast.be4_1))
      return false;
    return true;
  }
}
class NotMappedException extends RuntimeException {
  constructor(clazz, requestedByClass, ctx, msg) {
    return new.target.je4(clazz, requestedByClass, ctx, msg);
  }
  static je4(clazz, requestedByClass, ctx, msg) {
    msg = msg === VOID ? 'Not mapped ' + toString(clazz) + ' requested by ' + toString(requestedByClass) + ' in ' + ctx.toString() : msg;
    var $this = this.xb(msg);
    captureStack($this, $this.ie4_1);
    $this.ee4_1 = clazz;
    $this.fe4_1 = requestedByClass;
    $this.ge4_1 = ctx;
    $this.he4_1 = msg;
    return $this;
  }
}
class Injector {
  constructor(parent, level) {
    parent = parent === VOID ? null : parent;
    level = level === VOID ? 0 : level;
    this.ke4_1 = parent;
    this.le4_1 = level;
    this.me4_1 = null;
    this.ne4_1 = LinkedHashMap.m7();
    var tmp = this;
    var tmp3_safe_receiver = this.ke4_1;
    var tmp0_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.oe4_1;
    tmp.oe4_1 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    this.qe4(getKClass(Injector), this);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.pe4_1 = ArrayList.p2();
  }
  re4() {
    var tmp0_elvis_lhs = this.me4_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp4_safe_receiver = this.ke4_1;
      tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.me4_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  se4() {
    return new Injector(this, this.le4_1 + 1 | 0);
  }
  qe4(clazz, instance) {
    // Inline function 'kotlin.apply' call
    var tmp0 = this.ne4_1;
    // Inline function 'kotlin.collections.set' call
    var value = new InstanceObjectProvider(instance);
    tmp0.b5(clazz, value);
    return this;
  }
  te4(clazz, gen) {
    // Inline function 'kotlin.apply' call
    var tmp0 = this.ne4_1;
    // Inline function 'kotlin.collections.set' call
    var value = new SingletonObjectProvider(gen);
    tmp0.b5(clazz, value);
    return this;
  }
  ue4(clazz, gen) {
    // Inline function 'kotlin.apply' call
    var tmp0 = this.ne4_1;
    // Inline function 'kotlin.collections.set' call
    var value = new PrototypeObjectProvider(gen);
    tmp0.b5(clazz, value);
    return this;
  }
  ve4(clazz, ctx) {
    var tmp0_elvis_lhs = this.ne4_1.w4(clazz);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp7_safe_receiver = this.ke4_1;
      tmp = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.ve4(clazz, ctx);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp8_safe_receiver = this.re4();
      var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : tmp8_safe_receiver(clazz, ctx);
      var tmp_1;
      if (tmp9_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.collections.set' call
        this.ne4_1.b5(clazz, tmp9_safe_receiver);
        tmp_1 = tmp9_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp_2 = tmp_0;
    return (tmp_2 == null ? true : isInterface(tmp_2, ObjectProvider)) ? tmp_2 : null;
  }
  we4(clazz, ctx) {
    var tmp0_elvis_lhs = this.ve4(clazz, ctx);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NotMappedException.je4(clazz, ctx.be4_1, ctx, "Class '" + toString(clazz) + "' doesn't have constructors " + ctx.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  xe4(clazz, ctx) {
    return this.we4(clazz, ctx).ye4(this);
  }
  ze4(clazz, ctx, $super) {
    ctx = ctx === VOID ? new RequestContext(clazz) : ctx;
    return $super === VOID ? this.xe4(clazz, ctx) : $super.xe4.call(this, clazz, ctx);
  }
  toString() {
    return 'Injector(level=' + this.le4_1 + ')';
  }
  ae5(instance) {
    if (!(instance == null) ? isInterface(instance, InjectorDependency) : false) {
      instance.be5(this);
    }
    if (!(instance == null) ? isInterface(instance, InjectorDestructor) : false) {
      this.pe4_1.d2(instance);
    }
    return instance;
  }
  ce5() {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.ne4_1.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var pair = _iterator__ex2g4s.r1();
      pair.k3().ce5();
    }
    var _iterator__ex2g4s_0 = this.pe4_1.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var deinit = _iterator__ex2g4s_0.r1();
      deinit.ce5();
    }
    this.pe4_1.a5();
  }
}
class InjectorDependency {}
class ObjectProvider {}
class InstanceObjectProvider {
  constructor(instance) {
    this.de5_1 = instance;
  }
  ye4(injector) {
    return this.de5_1;
  }
  ce5() {
    var tmp = this.de5_1;
    var tmp1_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ce5();
    }
  }
  toString() {
    return 'InstanceObjectProvider(' + toString_0(this.de5_1) + ')';
  }
}
class SingletonObjectProvider {
  constructor(generator) {
    this.ee5_1 = generator;
    this.fe5_1 = null;
  }
  ye4(injector) {
    if (this.fe5_1 == null)
      this.fe5_1 = injector.ae5(this.ee5_1(injector));
    return ensureNotNull(this.fe5_1);
  }
  ce5() {
    var tmp = this.fe5_1;
    var tmp0_safe_receiver = (tmp == null ? true : isInterface(tmp, InjectorDestructor)) ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ce5();
    }
  }
  toString() {
    return 'SingletonObjectProvider(' + toString_0(this.fe5_1) + ')';
  }
}
class PrototypeObjectProvider {
  constructor(generator) {
    this.ge5_1 = generator;
  }
  ye4(injector) {
    return injector.ae5(this.ge5_1(injector));
  }
  ce5() {
    return Unit_instance;
  }
  toString() {
    return 'PrototypeObjectProvider()';
  }
}
class InjectorDestructor {}
class Companion_0 {}
class InjectorContext {
  constructor(injector) {
    this.he5_1 = injector;
  }
  j3() {
    return Companion_instance_0;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function *injector($completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp11_safe_receiver = $completion.od().ae(Companion_instance_0);
  var tmp0_elvis_lhs = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.he5_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Injector not in the context, please call withInjector function';
    throw IllegalStateException.o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(RequestContext, 'RequestContext');
initMetadataForClass(NotMappedException, 'NotMappedException');
initMetadataForClass(Injector, 'Injector', Injector);
initMetadataForInterface(InjectorDependency, 'InjectorDependency');
initMetadataForInterface(ObjectProvider, 'ObjectProvider');
initMetadataForClass(InstanceObjectProvider, 'InstanceObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(SingletonObjectProvider, 'SingletonObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForClass(PrototypeObjectProvider, 'PrototypeObjectProvider', VOID, VOID, [ObjectProvider]);
initMetadataForInterface(InjectorDestructor, 'InjectorDestructor');
initMetadataForCompanion(Companion_0);
protoOf(InjectorContext).ae = get;
protoOf(InjectorContext).dp = fold;
protoOf(InjectorContext).cp = minusKey;
protoOf(InjectorContext).ep = plus;
initMetadataForClass(InjectorContext, 'InjectorContext', VOID, VOID, [Element]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  injector as injector2qmvxvrtuuv,
  InjectorContext as InjectorContextps0ngmjb9onz,
  InjectorDependency as InjectorDependency2f8dsqe1kn3nn,
  Injector as Injectorxjyp19tp5mfu,
};
//endregion
